import { render, staticRenderFns } from "./grab.vue?vue&type=template&id=27a10bdc&scoped=true&"
import script from "./grab.vue?vue&type=script&lang=js&"
export * from "./grab.vue?vue&type=script&lang=js&"
import style0 from "./grab.vue?vue&type=style&index=0&id=27a10bdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a10bdc",
  null
  
)

export default component.exports